import navbar from './navbar';
import jobForm from './jobForm';
import { templates, templatesList } from './templates';
import jobs from './jobs';
import home from './home';
import bulkApprove from './bulkApprove';
import { loading, loadingError } from './loading';
import reportsTransactions from './reportsTransactions';
import timeAndAttendance from './timeAndAttendance';
import { errors } from './errors';
import { notifications } from './notifications';
import workforce from './workforce';
import modals from './modals';
import overviewChart from './overviewChart';
import overviewCharts from './overviewCharts';
import venues from './venues';
import quality from './quality';
import summaryReport from './summaryReport';
import { pinsPage } from './pins';
import importJobs from './importJobs';
import alerts from './alerts';
import filters from './filters';
import jobRequestDetails from './jobRequestDetails';
import notificationPreferences from './notificationPreferences';
import wandas from './wandas';
import pages from './pages';
import { uploadModal } from './uploadModal';
import { jobsReport } from './jobsReport';
import header from './header';
import banners from './banners';
import inputs from './inputs';

const USEnglish = {
  inputs,
  header,
  jobsReport,
  modals,
  pages,
  jobRequestDetails,
  alerts,
  importJobs,
  pinsPage,
  quality,
  bulkApprove,
  home,
  errors,
  uploadModal,
  jobs,
  jobForm,
  notifications,
  loading,
  loadingError,
  reportsTransactions,
  timeAndAttendance,
  summaryReport,
  workforce,
  overviewChart,
  overviewCharts,
  venues,
  filters,
  wandas,
  notificationPreferences,
  banners,
  common: {
    1099: '1099',
    W2: 'W2',
    hourly: 'Hourly',
    flatRate: 'Flat Rate',
    wonoloers: 'Wonoloers',
    update: 'Update',
    select: 'Select',
    selectAll: 'Select All',
    clearSelection: 'Clear Selection',
    email: 'Email',
    search: 'Search',
    add: 'Add',
    apply: 'Apply',
    clear: 'Clear',
    clearAll: 'Clear All',
    details: 'Details',
    empty: 'Empty',
    to: 'To',
    or: 'or',
    next: 'Next',
    nevermind: 'Nevermind',
    back: 'Back',
    favorite: 'Favorite',
    unfavorite: 'Unfavorite',
    confirm: 'Confirm',
    continue: 'Continue',
    close: 'Close',
    delete: 'Delete',
    done: 'Done',
    copy: 'Copy',
    post: 'Post',
    edit: 'Edit',
    repost: 'Repost',
    extend: 'Extend',
    save: 'Save',
    saveChanges: 'Save Changes',
    discardChanges: 'Discard Changes',
    unsavedChanges: 'Unsaved Changes',
    keepEditing: 'Keep Editing',
    cancel: 'Cancel',
    submit: 'Submit',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    numberSymbol: '#',
    optional: 'optional',
    optionalParens: '(optional)',
    maximum: 'maximum',
    na: 'Not Available',
    exportCsv: 'Export CSV',
    job: 'Job',
    postAJob: 'Post a Job',
    reserved: 'Reserved',
    agree: 'Agree',
    signIn: 'Sign In',
    signOut: 'Sign Out',
    create: 'Create',
    updated: 'Updated',
    remove: 'Remove',
    lastUsed: 'Last Used %lastUsed%',
    neverUsed: 'Has not been used',
    // filters //
    dateRange: 'Date Range',
    venues: 'Locations',
    startDate: 'Start date',
    endDate: 'End date',
    cancellationPolicy: "Please note that cancellations within 12 hours of the job may result in cancellation fees worth 50% of the Wonoloer's pay, in accordance with Wonolo's Customer Agreement.",
    // --end-- //
    time: {
      // use pluralize package to transform time unit to units e.g. pluralize(getText('common.time.hour'), hours)
      hour: 'hour',
      minute: 'minute',
    },
    minutes: '%minutes% minutes',
    tempToHire: 'TEMP-TO-HIRE',
    characterLimit: '%characterLength%/%characterLimit% characters',
    hourlyPay: '%payRate% hourly',
    flatPay: '%payRate% flat rate',
    learnMore: 'Learn more',
    contactUs: 'Contact us',
    exit: 'Exit',
    emptyTitle: 'No %resource% were found',
    backgroundChecks: {
      description: 'These checks apply in addition to our standard background check.',
      none: 'Only our standard background check applies to this job.',
      loadError: "We couldn't load the background checks for this job.",
      statuses: {
        REQUIRED: {
          title: 'Required',
          description: 'Wonoloers must pass these before they can start the job.',
        },
        SOFT_REQUIRED: {
          title: 'Can start while pending',
          description: 'Wonoloers can start the job while these are still pending.',
        },
        EXEMPT: {
          title: 'Exempt',
          description: 'This job is exempt from these checks.',
        },
      },
    },
    wonoloAdminOnly: {
      label: 'Wonolo admin only',
      admin: '%name% (%email%)',
      unknownAdmin: 'a Wonolo admin',
      visibility: 'Shown only because %admin% is logged in as this requestor from admin. Customers don\'t see this.',
      expired: 'Your Wonolo admin session has expired. Log in as this requestor again from admin to use admin tools.',
    },
  },
  prompts: {
    confirm: 'Please Confirm',
  },
  navbar,
  customerSettings: {
    editCompany: 'Edit Company',
    primaryContact: 'Primary Contact',
    billingContact: 'Billing Contact',
    imageUploaders: 'Add/Edit Images',
    settings: 'Settings',
    companyInformation: 'Company Information',
    saveChanges: 'Save Changes',
    cancel: 'Cancel',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone Number',
    businessName: 'Business Name',
    address: 'Address',
    city: 'City',
    state: 'State',
    zip: 'Zip',
    logo: 'Logo',
    workplaceImage: 'Workplace Image',
    budget: 'Budget',
    pin: 'Reveal Complete PIN (hours)',
    contactSupport:
      'To update company logo or workplace image, please contact support',
    logoCropModalTitle: 'Crop Your Company Logo Picture',
    logoSubmit: 'Set New Company Logo Picture',
    workplaceImageCropModalTitle: 'Crop Your Workplace Picture',
    workplaceImageSubmit: 'Set New Workplace Picture',
  },
  templatesList,
  jobFormErrors: {
    cannotSave: 'We were unable to save this form',
    jobRequestName: 'Please enter a unique job name',
    owner: 'Please choose a job owner',
    contactName: 'Please enter a contact name',
    contactPhone: 'Please enter a contact number',
    description: 'Please enter task information',
    descriptionTooLong:
      'You have exceeded the maxmium content for the task info, please edit your content',
  },
  formErrors: {
    requiredPay: 'Must include pay',
    negativePay: 'Pay must be a positive number',
    wrongPayType: 'Pay must be a number',
    lowPay:
      'This pay is below the minimum wage for %location%. Input a pay that is greater than %min%',
    missingFirstName: 'Must have a first name',
    missingLastName: 'Must have a last name',
    missingEmail: 'Must have an email',
    invalidEmail: 'Invalid email',
    missingPhone: 'Please enter a phone number',
    invalidPhone:
      'Please enter your phone number in the format: (123) 456-7890',
    missingCompanyName: 'Name is required',
    missingAddress: 'Address is required',
    missingName: 'Name is required',
    mustBeNumeric: 'This field must be a number',
    missingCity: 'Please enter a city name',
    missingState: 'Please choose a state',
    missingZipcode: 'Please enter a zip code',
    invalidZipcode:
      'The ZIP you have entered is invalid, please enter a valid ZIP.',
    missingCreditCardNumber: 'Please enter a credit card number',
    required: 'required',
    missingCategory: 'Please choose a category',
    atLeastOneSlot: 'Please enter at least one Wonoloer',
    blankStartTime: 'Please enter a start time',
    atLeastFiveMins: 'Please enter at least 1 minute of paid time',
    invalidStartDate: 'Please select a valid start date',
    startTimeInPast: 'Please select a start time in the future',
    paidHoursMax: 'Please enter a value less than 24 for paid hours',
    breakHoursMax: 'Please enter a value less than 24 for break hours',
    paidMinutesMax: 'Please enter a value less than 60 for paid minutes',
    breakMinutesMax: 'Please enter a value less than 60 for break minutes',
    tooManyWonoloers: 'Please enter a value less than 1000',
    cannotBeLessThan0: 'Please enter a value greater than 0',
    assignedBadge: 'Please select a badge to award',
    maxImageWidth: 'The image exceeds the maximum width',
    maxImageHeight: 'The image exceeds the maximum height',
    maxFileSize: 'The image size cannot be greater than %maxSize%',
  },
  formatErrors: {
    phone: 'Please enter your phone number in the format: (123) 456-7890',
    postal: 'Please enter a 5-digit zip code',
  },
  page404: {
    errorMsg: '404 ERROR',
    theWorkersYouSeek: 'The workers you seek are out there.',
    thePageYouSeek: 'The page you seek is not.',
  },
  errorBoundary: {
    header: 'Oops',
    message: 'We were unable to load this part of the site.',
  },
  wonoloers: {
    wonoloers: 'Wonoloers',
  },
  buttons: {
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    block: 'Block',
    unblock: 'Unblock',
    team: 'Team',
    search: 'Search',
    send: 'Send',
    invite: 'Invite',
    csv: 'CSV',
  },
  tooltips: {
    buttonClose: 'Close',
  },
  transactionDetails: {
    noSuchId: 'Unable to load transaction details',
    noDetails: 'Unable to load transaction details',
    totalCost: 'Total Cost',
    transactionDetails: 'Transaction Details',
    refNo: 'REF NO',
    wonoloer: 'WONOLOER',
    jobName: 'JOB NAME',
    startDateTime: 'START DATE & TIME',
    approved: 'APPROVED',
    pay: 'PAY',
    fee: 'FEE',
    total: 'TOTAL',
    charge: 'Charge',
    date: 'Date',
    billingPeriod: 'Billing Period',
    nightly: 'Nightly',
    amountDue: 'Amount Due',
    chargeTo: 'Charge To',
    overtime: 'Overtime',
  },
  dateRangePicker: {
    selectStartDate: 'Select start date',
    selectEndDate: 'Select end date',
    from: 'From',
    to: 'To',
    clear: 'Clear',
  },
  transactionsView: {
    pageTitle: 'Transactions',
    date: 'DATE',
    type: 'TYPE',
    description: 'DESCRIPTION',
    amount: 'AMOUNT',
    balance: 'BALANCE',
    pendingCharges: 'Pending Charges',
    pendingTransactions: 'Pending Transactions',
    transactions: 'Transactions',
    upcomingCharge: 'Upcoming charge...',
    charge: 'Charge',
    payment: 'Payment',
    noTransactions: 'No transactions found',
    contactEmail: 'businesssupport@wonolo.com',
    currentBalance: 'Current Balance',
    availableCredit: 'Available Credit',
    availableCreditTooltip:
      'Your available credit is up to date with the latest transactions, including pending charges and posted jobs. If you are approaching your limit, we recommend paying off the current balance. If you and would like to increase your available credit, please contact <a href="mailto:%email%">%email%</a>.',
    currentBalanceTooltip:
      'Your current balance is the amount that will be charged next.',
    messaging: {
      overLimitHeadline: 'You are over your credit limit!',
      overLimitBody:
        'You have gone over your credit limit of %limit% To prevent your account from being restricted, please pay off the current balance at your earliest convenience. For any additional help, please contact us at <a href="mailto:%email%">%email%</a>.',
      businessAsUsualHeadline: "You don't have a payment due right now",
      businessAsUsualBody: 'Your billing period is nightly',
      declinedHeadline: 'Your payment has been declined',
      declinedBody: 'We were unable to process your payment',
      nearLimitHeadline: 'You are approaching your credit limit!',
      nearLimitBody: 'You are approaching your credit limit of %limit%',
    },
    chargeDescription: 'Charge #%chargeId%',
    paymentDescription: 'Paid with %cardType% ****%lastFour%',
    paymentDeclined: 'Payment declined for %cardType% ****%lastFour%',
  },
  magicAlgorithm: {
    thankYou: 'Thank you for posting a job!',
    wonoloersFound:
      'We found over <b>%totalWonoloers%</b> qualified Wonoloers for this job in your area.',
    action: 'Now sit back and relax while your job gets filled.',
    ratingHeader: 'Average Wonoloer Rating',
    recentJobsHeader:
      '# of Wonoloers who have recently completed a job in the :category category',
    tenPlusJobsHeader: '# of Wonoloers who have completed 10 jobs or more',
    viewStatus: 'View Job Status',
    postJob: 'Post Another Job',
  },
  days: {
    day: 'day',
    until: 'until',
    every: 'every',
    weekend: 'weekend',
    weekday: 'weekday',
    sunday: 'sunday',
    monday: 'monday',
    tuesday: 'tuesday',
    wednesday: 'wednesday',
    thursday: 'thursday',
    friday: 'friday',
    saturday: 'saturday',
  },
  daysAbbrv: {
    sunday: 'Sun',
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat',
  },
  time: {
    hourly: 'Hourly',
    daily: 'Daily',
  },
  cropImage: {
    limit: 'jpg, jpeg, png images only. Maximum file size 2MB',
  },
  imagePreview: {
    noImageAvailable: 'No Image Available',
  },
  templates,
  tryoutConfirmation: {
    createdTitle: 'Add This Badge To A Job',
    createdBody1:
      'Congratulations! You have just completed posting a tryout, anyone who successfully completes it will earn the %badgeName% badge.',
    createdBody2:
      'We suggest you immediately update any appropriate job templates with the badge; and in the next 1-2 weeks add this badge to any appropriate jobs you may will be posting. ',
    postJobTitle: 'Post a Job',
    postJobBody:
      'Create a new job and attach this badge to it. Only people with the new badge will be able to accept!',
    updateTemplateTitle: 'Update An Existing Template',
    updateTemplateBody:
      'Update an existing template to include this training’s badge. Only people with the new badge will be able to accept!',
    update: 'Update',
    post: 'Post New',
  },
};

export default USEnglish;
